//* 오리진 검사만으론 `/..//evil.com`이, 선두 슬래시 검사만으론 URL 파서가 걷어내는 `/\t/evil.com`이 빠져나간다 — 둘 다 건다
const DUMMY_ORIGIN = 'https://wello.invalid';

const INTERNAL_PATH_PATTERN = /^\/(?!\/|\\)/;

export const toSafeRedirectPath = (
  requestedPath: string | null | undefined,
  fallbackPath: string,
) => {
  if (!requestedPath) {
    return fallbackPath;
  }

  try {
    const parsed = new URL(requestedPath, DUMMY_ORIGIN);

    if (parsed.origin !== DUMMY_ORIGIN) {
      return fallbackPath;
    }

    const path = parsed.pathname + parsed.search + parsed.hash;

    return INTERNAL_PATH_PATTERN.test(path) ? path : fallbackPath;
  } catch {
    return fallbackPath;
  }
};
